import { useInView } from "../hooks/useInView";
import { Accordion, type AccordionItem } from "./Accordion";

const faqs: AccordionItem[] = [
  {
    id: "faq-what-is-dough",
    question: "What is Dough?",
    answer:
      "Dough is a personal finance app built for college students. It combines short lessons, a 7-day life simulation game, an AI coach, goal-setting tools, and competitions to make learning about money actually useful and fun.",
  },
  {
    id: "faq-who-is-dough-for",
    question: "Who is Dough for?",
    answer:
      "Dough is designed for college students. No prior finance knowledge needed.",
  },
  {
    id: "faq-is-dough-free",
    question: "Is Dough free to download?",
    answer:
      "Yes. Dough is free to download on the App Store and Google Play.",
  },
  {
    id: "faq-what-is-the-sim",
    question: "What is the Sim?",
    answer:
      "The Sim is a 7-day life simulation where you play as a college student managing six real-life stats: cash, savings, debt, happiness, stress, and health. Each day you face financial decisions with real consequences. It\u2019s the core game in Dough \u2014 challenging, replayable, and nothing like any other finance app.",
  },
  {
    id: "faq-what-is-the-coach",
    question: "What is the Coach?",
    answer:
      "The Coach is an AI-powered finance assistant inside the app. It helps you build real-world action plans \u2014 not just in-app habits \u2014 so what you learn in Dough actually changes how you handle your money.",
  },
  {
    id: "faq-competitions-and-prizes",
    question: "How do Competitions and prize drawings work?",
    answer:
      "Partner program users earn raffle tickets just by using the app \u2014 completing lessons, playing the Sim, and taking daily quizzes all count. Those tickets enter you in a grand prize drawing. Partner users also compete in weekly Sim competitions against other students in their program, with separate prizes for top performers.",
  },
  {
    id: "faq-how-to-earn-tickets",
    question: "How do I earn tickets?",
    answer:
      "Tickets are earned automatically when you complete in-app activities: finishing a lesson, playing the Sim, or completing a daily quiz. Every eligible action counts \u2014 the more you use the app, the more entries you earn.",
  },
  {
    id: "faq-partner-program-required",
    question: "Do I need to be part of a partner program to use Dough?",
    answer:
      "No. Anyone can download and use Dough for free. Partner programs add an extra layer of competitions and prize eligibility for students at participating schools.",
  },
  {
    id: "faq-data-safety",
    question: "Is my personal or financial data safe?",
    answer:
      "Yes. Dough does not connect to your bank accounts or store sensitive financial credentials. See our Privacy Policy for full details.",
  },
  {
    id: "faq-contact-support",
    question: "How do I delete my account or contact support?",
    answer:
      "You can manage your account from the Profile tab in the app. For support, email us at help@betteryou.ai or use the contact form below.",
  },
];

export function FAQ() {
  const [ref, inView] = useInView();

  return (
    <section id="faq" className="relative py-24 bg-bg-primary">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-brand-teal font-semibold tracking-wide uppercase text-sm mb-3">
            Support
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold text-white">
            Frequently asked{" "}
            <span className="text-brand-teal">questions</span>
          </h2>
        </div>

        <div
          ref={ref}
          className={inView ? "animate-fade-up" : "start-hidden"}
        >
          <Accordion items={faqs} />
        </div>
      </div>
    </section>
  );
}
